import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_permissions';
export const useUserPermissionsTranslation = () => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    toast_success: 'Доступы пользователя успешно обновлены',
    toast_error: 'Не удалось обновить доступы пользователя',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    toast_success: 'User permissions updated successfully',
    toast_error: 'Failed to update user permissions',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    toast_success: 'Permisos de usuario actualizados correctamente',
    toast_error: 'Error al actualizar los permisos de usuario',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    toast_success: 'Permissões do usuário atualizadas com sucesso',
    toast_error: 'Falha ao atualizar as permissões do usuário',
  },
}) as Record<string, unknown>;
